import React from "react";
import { Box, VStack, Button, Text, Flex, Spinner } from "@chakra-ui/react";
import { LuPlus } from "react-icons/lu";

const VariantSidebar = ({ 
  versions, 
  activeVersion, 
  setActiveVersion, 
  onAddVersion, 
  loading = false,
  canAddVersion = true 
}) => {
  return (
    <Box
      w="200px"
      minW="200px"
      flexShrink={0}
      bg="white"
      borderRight="1px solid"
      borderColor="gray.200"
      h="100%"
      borderRadius="md"
      shadow="sm"
      display="flex"
      flexDirection="column"
      position="relative"
    >
      {/* Scrollable Versions */}
      <Box flex="1" overflowY="auto" p={3} pb={12}>
        <Text
          fontSize="xs"
          fontWeight="bold"
          color="gray.600"
          textTransform="uppercase"
          letterSpacing="0.6px"
          mb={2}
        >
          Versions
        </Text>
        
        {loading ? (
          <Flex justify="center" py={4}>
            <Spinner size="sm" />
          </Flex>
        ) : versions.length > 0 ? (
          <VStack align="stretch" spacing={2}>
            {versions.map((version) => {
              const isActive = activeVersion === version.id;
              return (
                <Flex
                  key={version.id}
                  onClick={() => setActiveVersion(version.id)}
                  align="center"
                  p={2}
                  borderRadius="md"
                  cursor="pointer"
                  fontSize="sm"
                  transition="all 0.2s"
                  bg={isActive ? "blue.500" : "white"}
                  color={isActive ? "white" : "gray.700"}
                  fontWeight={isActive ? "semibold" : "normal"}
                  borderLeft="3px solid"
                  borderColor={isActive ? "blue.600" : "transparent"}
                  _hover={{
                    bg: isActive ? "blue.600" : "blue.50",
                    color: isActive ? "white" : "blue.700",
                  }}
                >
                  Version {version.version}
                </Flex>
              );
            })}
          </VStack>
        ) : (
          <Text fontSize="sm" color="gray.500" textAlign="center" py={4}>
            No versions available
          </Text>
        )}
      </Box>

      {/* Sticky Add Button */}
      {canAddVersion && (
        <Box
          position="sticky"
          bottom="0"
          bg="white"
          px={3}
          py={2}
          borderTop="1px solid"
          borderColor="gray.200"
        >
          <Button
            w="100%"
            size="sm"
            borderRadius="md"
            colorScheme="blue"
            leftIcon={<LuPlus />}
            onClick={onAddVersion}
            fontWeight="medium"
            isDisabled={loading}
          >
            Add Version
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default VariantSidebar;